module.exports = __webpack_public_path__ + "public/images/reviews/aleksanrd-stahurskiy.3ce4c0aac7ec88c301646453ca761f94.jpg";